"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SampleCSVMetadata {
    constructor() {
        this.values = {};
    }
    getValue(id) {
        const val = this.values[id];
        if (val === undefined)
            return null;
        return val;
    }
    addValue(id, value) {
        this.values[id] = value;
    }
    reset() {
        this.values = {};
    }
}
exports.default = SampleCSVMetadata;
